import React, { useState } from 'react';
import { login, signup } from '../state/api';
import { Text, Banner } from '../components/ui';
import { useTheme } from '../state/store';

export default function Auth({ onAuthed }) {
  // Public pages always follow the OS — do not overwrite the signed-in theme preference.
  useTheme('system', { persist: false });

  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [orgName, setOrgName] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      if (mode === 'signup') {
        await signup({ email, password, displayName, orgName });
      } else {
        await login({ email, password });
      }
      onAuthed?.();
    } catch (err) {
      setError(err.message || 'Authentication failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-brand">Bridge45</div>
        <p className="auth-sub">
          {mode === 'login'
            ? 'Sign in to your organization war room.'
            : 'Create an organization and owner account.'}
        </p>

        {error && <Banner tone="bad">{error}</Banner>}

        <form className="auth-form" onSubmit={submit}>
          {mode === 'signup' && (
            <>
              <Text label="Organization" value={orgName} onChange={setOrgName} />
              <Text label="Your name" value={displayName} onChange={setDisplayName} />
            </>
          )}
          <Text label="Email" type="email" value={email} onChange={setEmail} />
          <Text
            label="Password"
            type="password"
            value={password}
            onChange={setPassword}
            help={mode === 'signup' ? 'At least 8 characters.' : undefined}
          />
          <button type="submit" className="btn primary" disabled={busy}>
            {busy ? 'Working…' : mode === 'login' ? 'Sign in' : 'Create organization'}
          </button>
        </form>

        <button
          type="button"
          className="btn ghost auth-switch"
          onClick={() => {
            setMode(mode === 'login' ? 'signup' : 'login');
            setError('');
          }}
        >
          {mode === 'login' ? 'Need an account? Sign up' : 'Already have an account? Sign in'}
        </button>
      </div>
    </div>
  );
}
